const LogApiService = {
    error: (error, marathonAppId) => {
        const message = error.name + ': ' + error.message;
        window.hexia.log.error(message, Object.assign(Object.assign({}, getContextData(marathonAppId)), { stackTrace: error.stack }));
    },
    log: (title, message, marathonAppId, type = LogTypes.info) => {
        window.hexia.log.log(type, title + ' ' + message, getContextData(marathonAppId), 'typo3');
    },
};
const getContextData = (marathonAppId) => {
    return {
        marathonAppId: marathonAppId,
    };
};
export const LogTypes = {
    info: 'info',
    warning: 'warning',
    error: 'error',
};
export default LogApiService;
